import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components_pro_devices from '@devices/settings/device_settings/virtual_components_pro_devices.js';
import networks_gen_2_pro from '@devices/settings/device_settings/networks_gen_2_pro.js';
import app_setting_gen_2 from '@devices/settings/device_settings/app_setting_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import settings_gen_2 from '@devices/settings/device_settings/settings_gen_2.js';
import bluetooth_bt_home_control_gen_2 from '@devices/settings/device_settings/bluetooth_bt_home_control_gen_2';
import addon_sensors, { addon_pro_devices } from '@devices/settings/device_settings/addon_sensors';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'ShellyPro2UL',
	friendly_name: 'Pro 2',
	family: 'relay',
	isPM: false,
	addons: addon_pro_devices,
	modes: {
		relay: {
			channels: 2,
			notifications: [
				'offline',
				'device_problem',
				'overpower',
				'forgotten_lights',
				'overtemperature',
			],
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				addon_sensors,
				scripts_gen_2,
				virtual_components_pro_devices,
				networks_gen_2_pro,
				bluetooth_bt_home_control_gen_2,
				app_setting_gen_2,
				share,
				settings_gen_2,
			],
		},
	},
};
